import { RefObject } from "react";
import { ViewTableHandle } from "@design-system/ViewTable/ViewTable";
import { useDocumentRefContextMaybe } from "./DocumentRefContext";
import { useRefRowHighlight } from "./useRefRowHighlight";

export function useDocumentRowHighlight<TRowId extends string | number>({
    resolveTableRowId,
    tableRef,
}: {
    resolveTableRowId: (documentId: number) => TRowId | undefined;
    tableRef?: RefObject<ViewTableHandle | null>;
}) {
    const docRefCtx = useDocumentRefContextMaybe();
    return useRefRowHighlight({
        focusedId: docRefCtx?.focusedDocumentId ?? null,
        resolveTableRowId,
        tableRef,
    });
}
